module.exports = "query AvailableProductInserts{productInserts{edges{node{id label:name value:id}}}}"